(function (module) {
  'use strict';
  module
    .controller('myAgencyController', ['$scope', 'progressBar',
      'myAgencyService', 'orgFilterService', 'organizations', 'authService', 'agencySettings', '$q',
      function ($scope, progressBar, myAgencyService, orgFilterService, organizations, authService, agencySettings,
        $q) {
        const progress = progressBar.getProgressBar();

        //executes when controller loads
        (function init() {
          getAgency();
        })();

        function getAgency() {
          $scope.agency = null;
          $scope.isNoAgency = false;
          $scope.isFiltered = true;
          progress.start();
          const promiseTimeZone = agencySettings.getWindowsTimeZones();
          const promiseAgencySettings = myAgencyService.getAgency(authService.getLoginMember().OrganizationId);
          $q.all([promiseTimeZone, promiseAgencySettings]).then(function (response) {
            $scope.timeZones = response[0].data;
            let agencyContext = response[1];
            if (!!agencyContext && !!agencyContext.TravelAgencyId) {
              $scope.isNoAgency = true;
              $scope.agency = {
                name: agencyContext.TravelAgency.Name,
                addressLine1: agencyContext.TravelAgency.AddressLine1,
                addressLine2: agencyContext.TravelAgency.AddressLine2,
                city: agencyContext.TravelAgency.City,
                stateProv: agencyContext.TravelAgency.StateProv,
                postalCode: agencyContext.TravelAgency.PostalCode,
                country: agencyContext.Country,
                phone: ((!!agencyContext.TravelAgencyPhone) ? agencyContext.TravelAgencyPhone : agencyContext
                  .TravelAgency.DefaultPhone),
                afterHoursPhone: ((!!agencyContext.TravelAgencyAfterHoursPhone) ? agencyContext.TravelAgencyAfterHoursPhone :
                  agencyContext.TravelAgency.DefaultAfterHoursPhone),
                email: ((!!agencyContext.TravelAgencyEmail) ? agencyContext.TravelAgencyEmail : agencyContext
                  .TravelAgency.DefaultEmail),
                webSite: agencyContext.TravelAgency.WebSite,
                logoImageLink: agencyContext.TravelAgency.LogoImageLink,
                startRegularHours: ((!!agencyContext.TravelAgencyStartRegularHours) ?
                  moment(agencyContext.TravelAgencyStartRegularHours, 'HH:mm').format('hh:mm a') :
                  moment(agencyContext.TravelAgency.DefaultStartRegularHours, 'HH:mm').format('hh:mm a')),
                endRegularHours: ((!!agencyContext.TravelAgencyEndRegularHours) ?
                  moment(agencyContext.TravelAgencyEndRegularHours, 'HH:mm').format('hh:mm a') :
                  moment(agencyContext.TravelAgency.DefaultEndRegularHours, 'HH:mm').format('hh:mm a')),
                windowsTimeZone: ((!!agencyContext.TravelAgency.TravelAgencyWindowsTimeZoneId) ?
                  agencyContext.TravelAgency
                  .TravelAgencyWindowsTimeZoneId : agencyContext.TravelAgency.DefaultWindowsTimeZone.Id),
                serviceStartDay: ((!!agencyContext.TravelAgencyServiceStartDay) ? agencyContext.TravelAgencyServiceStartDay :
                  agencyContext.TravelAgency.DefaultServiceStartDay),
                serviceEndDay: ((!!agencyContext.TravelAgencyServiceEndDay) ? agencyContext.TravelAgencyServiceEndDay :
                  agencyContext.TravelAgency.DefaultServiceEndDay),
                internationalPhone: 'not available',
                timezone: '',
              };
            } else {
              $scope.isNoAgency = false;
              $scope.agency = null;
            }
          }).finally(function () {
            progress.complete();
          });
        }

        $scope.checkAddress = function () {
          if ($scope.agency != null) {
            const agency = $scope.agency;
            return (!!agency.addressLine1 || !!agency.addressLine2) && !!agency.city && !!
              agency.stateProv && !!agency.postalCode && !!agency.country;
          } else {
            return false;
          }
        };

        $scope.checkAgencyDetails = function () {
          if ($scope.agency != null) {
            const agency = $scope.agency;
            return (!!agency.phone || !!agency.afterHoursPhone || !!agency.email || !!agency.webSite ||
              !!agency.logoImageLink || !!agency.startRegularHours ||
              !!agency.windowsTimeZone || !!agency.serviceStartDay || !!agency.serviceEndDay);
          } else {
            return false;
          }
        };
      },
    ]);
})(angular.module('obex'));



// WEBPACK FOOTER //
// ./client/js/controllers/myAgencyController.js